import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "../../../../../components/searchables";
import { MDBBtn, MDBIcon, MDBView } from "mdbreact";
import {
  BROWSE,
  SetActiveView,
  SetFILTERED,
  SetCREATE,
} from "../../../../../services/redux/slices/diagnostics/clinic/clinicMenus";
import { getMenuPhysicians, getPhysicianRecordId } from "./utils";

const Header = () => {
  const { token, activePlatform, auth } = useSelector(({ auth }) => auth);
  const {
    filtered = [],
    collections = [],
    activeView,
  } = useSelector(({ clinicMenus }) => clinicMenus);
  const { collections: clinics = [] } = useSelector(
    ({ clinicInfo }) => clinicInfo,
  );
  const dispatch = useDispatch();

  const physicians = useMemo(() => {
    return getMenuPhysicians({
      activePlatform,
      clinics,
      authId: auth?._id,
    })
      .map(getPhysicianRecordId)
      .filter(Boolean);
  }, [activePlatform, clinics, auth?._id]);

  useEffect(() => {
    if (token && physicians.length > 0) {
      dispatch(
        BROWSE({
          token,
          key: { physicianId: physicians },
        }),
      );
    }
  }, [token, dispatch, physicians]);

  const filteredCount = filtered.filter(({ itemType }) =>
    activeView === "meds" ? itemType === "meds" : itemType !== "meds",
  ).length;

  return (
    <MDBView
      cascade
      className="gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
    >
      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
        <span className="white-text mx-3 text-nowrap mt-0">
          {filteredCount} {activeView === "meds" ? "meds" : "Services"}
        </span>
        <div className="d-flex" style={{ gap: "8px" }}>
          <button
            type="button"
            className={`btn btn-sm ${activeView === "service" ? "btn-light" : "btn-outline-light"}`}
            onClick={() => dispatch(SetActiveView("service"))}
          >
            Services
          </button>
          <button
            type="button"
            className={`btn btn-sm ${activeView === "meds" ? "btn-light" : "btn-outline-light"}`}
            onClick={() => dispatch(SetActiveView("meds"))}
          >
            Medicines
          </button>
        </div>
      </div>
      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
        <Search
          collections={collections}
          setFiltered={(items) => dispatch(SetFILTERED(items))}
          haveAction={false}
          reset={() => dispatch(SetFILTERED(collections))}
          hideButton={false}
        />
        <MDBBtn
          size="sm"
          color="light"
          className="m-0 px-3"
          onClick={() => dispatch(SetCREATE())}
        >
          <MDBIcon icon="plus" className="mr-1" />
          Add Menu
        </MDBBtn>
      </div>
    </MDBView>
  );
};

export default Header;
